import React, { useEffect, useState } from 'react';

import ComboBox from '../../../../components/ComboBox';
import CollapsableSection from '../../../../components/CollapsibleSection';
import ButtonForm from '../../../../components/ButtonForm';
import InputForm from '../../../../components/InputForm';
import SelectableList from '../../../../components/SelectableList';
import SelectionForm from '../../../../components/SelectionForm';

import CheckIco from '../../../../components/icons/CheckIco';
import TrashIco from '../../../../components/icons/TrashIco';
import AddIco from '../../../../components/icons/AddIco';

import Spinner from '../../../../components/Spinner';
import { useAuth } from '../../../../providers/AuthContext';
import { useAppContext } from '../../../../providers/AppContext';
import { useNavigate } from 'react-router-dom';
import { useWidgets } from '../../../../providers/WidgetContext';
import { useDashboards } from '../../../../providers/DashboardContext';
import { createWidget, getWidgetById, updateWidget } from '../../../../services/apiWidgests';
import { getAllParameters } from '../../../../services/apiProcessParameteres';
import { translateDatePicker } from '../../../utils';
import { useProcesses } from '../../../../providers/ProcessesContext';
import { getAllDevices } from '../../../../services/apiDevices';
import { getAllVariables, getVariablesByDevice } from '../../../../services/apiVariables';

const ColumnField = ({ header , onDelete=() =>{}}) => {
  return (
    <div className='flex justify-between items-center w-full mr-3'>
      <div className='flex basis-1/3 items-center gap-1'>
        <span>{header.alias || header.name}</span>
      </div>
      <span className='basis-1/3 text-gray-400'>{header.key}</span>
      <button className="" onClick={() => onDelete(header)}>
        <TrashIco fill='red' />
      </button>
    </div>
  );
};

function TelemetryLineChartForm({onSubmit = () => {}, id}) {
  const {auth} = useAuth();
  const {addToast} = useAppContext();
  const navigate = useNavigate();
  
  const { addCard, assignSpace } = useWidgets();
  const { dashboard , selectedTab} = useDashboards();
  
  const [devicesList, setDevicesList] = useState({});
  const [selectedDevice, setSelectedDevice] = useState();
  const [parameters, setParameters] = useState();
  const [variables, setVariables] = useState();
  //const {menuItems} = useProcesses();
  const [dataRange, setDataRange] = useState('Asignar por dashboard');
  const [title, setTitle] = useState('');
  const [validate, setValidate] = useState(false);
  const [conf, setConf] = useState();
  const [toCompare, setToCompare] = useState();
  const [valueToCompare, setValueToCompare] = useState();
  const [aggregation, setAggregation] = useState("add");
  const [timespan, setTimespan] = useState("hours");
  const [interval, setInterval] = useState(1);
  const [stage,setStage] = useState("form");

  const aggregationOptions = {
    "add": "Suma",
    "mean": "Promedio",
    "max": "Máximo",
    "min": "Mínimo",
    "count": "Conteo"
  }
  const timeOptions = {
    "minutes": "Minutos",
    "hours": "Horas",
    "days": "Días",
    "weaks": "Semanas",
    "months": "Meses"
  }
  //backend flags
  const [loading, setLoading] = useState(true);
  const [fetchingVariables, setFechingVariables] = useState(true);
  const [creatingWidget, setCreatingWidget] = useState(false);
  const [fetchingWidgetInfo, setFetchingWidgetInfo] = useState(true);

  //obtener info existente del widget
  const refreshWidgetInfo = () => {
    async function fetchWigdet(){
      const widget = await getWidgetById(id, auth?.token);
      return widget; 
    }
    try {
      setFetchingWidgetInfo(true);
      fetchWigdet().then(response => {
        console.log(response.configuration)
        setConf(response.configuration)
        //setSelectedProcess(response.configuration.process.id)
        setTimespan(response.configuration.timespan)
        setAggregation(response.configuration.aggregation)
        setInterval(response.configuration.interval)
        //setDataRange(response.configuration.dateRange.selectedRange === "byDashboard" ? "Asignar por dashboard": response.configuration.dateRange.selectedRange)
        setFetchingWidgetInfo(false);
        setTitle(response.title)
      }).catch(error => {
        if (error.response.status === 404){
          console.log("Widget no encontrado")
        }
        else if (error.response.status === 500){
          console.log("Error en el servidor, intente nuevamente")
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error,typeof(error));
      setFetchingWidgetInfo(false);
    }
  }
  
  //obtener info existente del widget
  const refreshDevices = () => {
    async function fetchDevices(){
      const widget = await getAllDevices(auth?.token);
      return widget; 
    }
    try {
      setFetchingWidgetInfo(true);
      fetchDevices().then(response => {
        console.log(response)
        let tempDevices = {}
        //mapear dispositivos
        response.map( infoDevice => tempDevices[infoDevice._id] = infoDevice.name || infoDevice.alias )
        console.log(tempDevices)
        setDevicesList({...tempDevices})
        
      }).catch(error => {
        if (error.response.status === 404){
          console.log("dispositivo no encontrado")
        }
        else if (error.response.status === 500){
          console.log("Error en el servidor, intente nuevamente")
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error,typeof(error));
      //setFetchingWidgetInfo(false);
    }
  }

  const refreshVariables = () => {
    async function fetchVariables(){
      const variables = await getVariablesByDevice(selectedDevice, auth?.token);
      //console.log(variables)
      return variables;
    }
    try {
      setFechingVariables(true);
      fetchVariables().then(response => {
         setVariables(response.map(variable => {
          return {
            name: variable.name,
            alias: variable.alias,
            _id: variable._id,
          }
        })); 
        setFechingVariables(false);
      }).catch(error => {
        if (error.response.status === 404){
          addToast("Dispositivo no encontrado",3)
        }
        else if (error.response.status === 500){
          addToast("Error en el servidor, intente nuevamente",2)
        }
        else if (error.response.status === 419){
          addToast("Sesión expirada",1)
          navigate('/logout')
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error, "a", typeof(error));
      setFechingVariables(false);
    }
  }

  const createWidgetDB = () => {
    async function fetchWidget(){
      const position= assignSpace();
      const widget = await createWidget({
        type: "telemetryLineGraph",
        title: title,
        description: "",
        configuration: conf,
        dashboardId: dashboard._id,
        x: position.x,
        y: position.y,
        width: 200,
        height: 200,
        selectedTab
      }, auth?.token);
      
      return widget;
    }
    try {
      setCreatingWidget(true);
      fetchWidget().then(response => {
        console.log(console.log(response));
        addCard (
          response._id,
          response.title,
          response.type,
          response.dashboardId,
          
        )
        onSubmit();
        setCreatingWidget(false);
        addToast("Widget "+ title + " creado exitosamente.",1)
      }).catch(error => {
        console.log(error)
        if (error.response.status === 404){
          addToast("Proceso no encontrado",3)
        }
        else if (error.response.status === 500){
          addToast("Error en el servidor, intente nuevamente",2)
        }
        else if (error.response.status === 419){
          addToast("Sesión expirada",1)
          navigate('/logout')
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error, "a", typeof(error));
      setCreatingWidget(false);
    }
  }

  const editWidgetDB = () => {
    async function saveWidget(){

      const widget = await updateWidget(id,{
        type: "telemetryLineGraph",
        title: title,
        description: "",
        configuration: conf,
        /* dashboardId: dashboard._id,
        x: position.x,
        y: position.y,
        width: 200,
        height: 200, */
      }, auth?.token);
      
      return widget;
    }
    try {
      setCreatingWidget(true);
      saveWidget().then(response => {
        console.log(console.log(response));
        
        onSubmit();
        setCreatingWidget(false);
        addToast("Widget "+ title + " editado exitosamente.",1);
      }).catch(error => {
        console.log(error)
        if (error.response.status === 404){
          addToast("Proceso no encontrado",3)
        }
        else if (error.response.status === 500){
          addToast("Error en el servidor, intente nuevamente",2)
        }
        else if (error.response.status === 419){
          addToast("Sesión expirada",1)
          navigate('/logout')
        }
        else{
          navigate('/logout')
        }
      })
    } catch (error) {
      console.log(error, "a", typeof(error));
      setCreatingWidget(false);
    }
  }

  const selectVariable = (selectedItems) => {
    if (variables && selectedItems){
      const selectedV = variables.find( element => {return selectedItems.includes( element.alias || element.name)});
      let tempConf = {...conf}
      tempConf.variable = selectedV
      setConf({...tempConf})
    }
    
  }
  const deleteToCompare = (selectedItems) => {
    if (parameters && selectedItems){
      let tempConf = {...conf}
      tempConf.variableToCompare = undefined
      setConf({...tempConf})
    } 
  }
  const selectValueToCompare = (selectedItems) => {
    if (parameters && selectedItems){
      const selectedValue = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
      let tempConf = {...conf}
      tempConf.valueToCompare = selectedValue
      setConf({...tempConf})
    }
  }
  const deleteValue = (selectedItems) => {
    if (variables && selectedItems){
      let tempConf = {...conf}
      tempConf.variable = undefined
      setConf({...tempConf})
    } 
  }
  
  const handleDeviceChange = (selectedDevice) => {
    let tempConf = {...conf}
    tempConf.variable = undefined;
    tempConf.device = {
      id: selectedDevice,
      name: devicesList[selectedDevice]
    }
    setConf({...tempConf})
  }
  const handleDataRangeChange = (selectedRange) => {
    setDataRange(translateDatePicker(selectedRange));
    let tempConf = {...conf}
    tempConf.dateRange = selectedRange
    setConf({...tempConf})
  }
  const handleDecimalsChange = (decimals) => {
    let tempConf = {...conf}
    tempConf.nDecimals = decimals
    setConf({...tempConf})
  }
  const handleChangeWidgetName = (name) => {
    setTitle(name)
  }
  const handleChangeAggregation = (aggregation) => {
    let tempConf = {...conf}
    tempConf.aggregation = aggregation
    setConf({...tempConf})
  }
  const handleChangeInterval = (interval) => {
    let tempConf = {...conf}
    tempConf.interval = Number(interval)
    setConf({...tempConf})
  }
  const handleChangeTimespan = (timespan) => {
    let tempConf = {...conf}
    tempConf.timespan = timespan
    setConf({...tempConf})
  }
  const handleCreateWidget = () =>{
    createWidgetDB();
  }
  const handleEditWidget = () =>{
    editWidgetDB();
  }
  useEffect( () => {
    if (selectedDevice){
      //limpiar variables
      //cargar los parametros
      refreshVariables();
      //actualizar la configuracion
      handleDeviceChange(selectedDevice);

    }
  }, [selectedDevice]);
  useEffect( () => {
     refreshDevices();
  }, []) 
  useEffect( () => {
    const bdConf = {
      process: undefined,
      variable: undefined, 
      dateRange: {
        "activeTab": "customDates",
        "selectedRange": "byDashboard"
      },
      nDecimals: 2,
      dateFormat: "mm/dd/yy - hh:mm",
      aggregation: "add",
      timespan: "hours",
      interval: 1
    }

    setLoading(true);
    //cargar campos
    //cargar conf
    /* let processOptions = {}
    menuItems.slice(1).map(element => 
      processOptions[element.id] = element.label
    )
    console.log(processOptions); */
    setConf(bdConf);
    //setProcessList(processOptions);
    setLoading(false);
  }, []);
  useEffect( () => {
    if (stage === "form"){

    }
    if (stage === "columnSection"){

    }
  }, [])

  useEffect( () => {
    if (
      title === "" ||
      !conf?.device ||
      !conf.variable ||
      !conf?.dateRange ||
      !conf?.nDecimals 
    ){
      setValidate(false);
    }
    else {
      setValidate(true);
    }
  }, [conf, title])

  useEffect( () => {
    if (id){
      refreshWidgetInfo()
    }
    setFetchingWidgetInfo(false)
    
  }, [id])

  return (
    <>
     {stage === "form" && (
      <>
        {conf && !fetchingWidgetInfo && (
            <div className='flex flex-col gap-2 h-[35rem] relative overflow-auto'>
              <div className=' flex flex-col flex-grow gap-2'>
                <CollapsableSection title={"Datos"} titleBgColor='bg-lightblue' titleTextColor='text-bluesens' open={true} border={false}>
                  <div className='flex flex-col gap-2'>
                    <div className='flex justify-between items-center w-[50%] mb-1.5'>
                      <SelectionForm
                        text="Dispositivo" 
                        options={Object.keys(devicesList)} 
                        mask={devicesList} 
                        value={selectedDevice}
                        onChange={event => setSelectedDevice(event)}
                        AppendClassName=' -mb-4'
                        error={false ? 'El dispositivo no tiene variables creadas' : ""}
                      /> 
                    
                    </div>
                    <CollapsableSection
                      title={"Variable"}
                      titleBgColor='bg-aliceblue'
                      titleTextColor='text-gray'
                      open={true}
                    >
                      <div className='w-full flex flex-col px-4'>
                        { conf.variable && (
                          <ColumnField header={conf.variable} onDelete={deleteValue}/>
                        )}
                        { !conf.variable && (
                          <div className=' mx-auto'>
                            <ButtonForm 
                              text={"Agregar variable"} 
                              Icon={() => {return (<AddIco fill='white'/>)}} 
                              enabled={selectedDevice}
                              action={ () => setStage("setVariable")}
                            />
                          </div>
                        )}
                      </div>
                    </CollapsableSection>
                    
                    {/* <div className='-mb-4 pt-2'>
                        <SelectionForm
                          text="Método de agregación" 
                          options={Object.keys(aggregationOptions)} 
                          mask={aggregationOptions}
                          value={aggregation}
                          onChange={event => handleChangeAggregation(event)}
                          AppendClassName=' -mb-4'
                        /> 
                    </div>
                    <div className='-mb-4 pt-4'>
                        <div className="flex gap-1 items-center">
                          <InputForm
                            text={"Intervalo"}
                            type="number"  
                            value={interval}
                            onChange={(event) => handleChangeInterval(event.target.value)}
                            AppendClassName=' -mb-4'
                          />
                          <SelectionForm
                            text="Tiempo"
                            value={timespan} 
                            options={Object.keys(timeOptions)} 
                            mask={timeOptions}
                            onChange={(event) => handleChangeTimespan(event)}
                            AppendClassName=' -mb-4'
                          /> 
                         
                        </div>
                    </div> */}
                    <div className='-mb-5 pt-4'>
                      <InputForm 
                        type={"datarange"} 
                        text={"Rango de tiempo"} 
                        value={dataRange} 
                        AppendClassName='text-left' 
                        onChange={(event) => handleDataRangeChange(event)}
                        dateRangeOptions={conf.dateRange}
                        addedRanges={ {"byDashboard": () => {}}} 
                      />
                    </div>
                    
                  </div>
                </CollapsableSection>
                <CollapsableSection title={"Apariencia"} titleBgColor='bg-lightblue' titleTextColor='text-bluesens' border={false} open={true}>
                  <div className='-mb-4 '>
                    <InputForm text={"Nombre"} value={title} onChange={(event) => setTitle(event.target.value)}/>
                  </div>
                  <div className='-mb-4 pt-2'>
                    <InputForm type={"number"} text={"Decimales"} value={conf.nDecimals} onChange={(event) => handleDecimalsChange(event.target.value)}/>
                  </div>
                  <div className='-mb-4 pt-2'>
                    <InputForm type={"button"} text={"Estilo"} value={"Modificar estilo"} AppendClassName='text-left' />
                  </div>
                </CollapsableSection>
              </div>

            {/* Span fijo al final del contenedor */}
            <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
              <div className='flex w-full justify-end'>
                <button className='' onClick={() => id ? handleEditWidget() : handleCreateWidget()}  disabled={!validate}>
                  <CheckIco width='50px' height='50px' fill={validate ? 'bluesens': 'gray'}/>
                </button>
              </div>
            </div>
          </div>
        )}
        {(!conf || fetchingWidgetInfo) && (
          <Spinner />
        )}
      </>
      
      
     )}
     {stage === "setVariable" && (
      <div className='flex flex-col gap-2 h-[25rem] relative overflow-auto '>
        <div className=' flex flex-col flex-grow gap-2'>
          <span className='font-semibold text-lg'>{"Seleccione variable"}</span>
          <SelectableList 
            items={variables.map(element => element.alias ? element.alias : element.name)} 
            multiSelect={false} 
            setItems={selectVariable}/>
        </div>
        
        {/* Span fijo al final del contenedor */}
        <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
          <div className='flex w-full justify-end'>
            < ButtonForm text={"Guardar"} enabled={true} action={() => setStage('form')}/>
          </div>
        </div>
      </div>
     )}
   
    </>
   
    
  );
}

export default TelemetryLineChartForm;
